module.exports = __webpack_public_path__ + "img/1f9f3.b2d3afc.svg";